import * as yup from 'common/yup';
import {DiplomatObject} from 'types/DiplomatObject';

export const SupportTicketNames = {
   description: 'description',
   includeLogs: 'includeLogs',
   includeConfig: 'includeConfig',
   transactions: 'transactions',
   logs: 'logs',
};

export const SupportTicketRequest = yup.object({
   [SupportTicketNames.transactions]: yup.array().of(DiplomatObject),
   [SupportTicketNames.description]: yup.string(),
   [SupportTicketNames.includeConfig]: yup.bool(),
   [SupportTicketNames.includeLogs]: yup.bool(),
   [SupportTicketNames.logs]: yup.string(),
});
export type ISupportTicketRequest = yup.InferType<typeof SupportTicketRequest>;
